export default __webpack_public_path__ + "static/media/editor.409ba876.webp";